// extracted by mini-css-extract-plugin
export default {"container":"container__CfRxe","lds-roller":"lds-roller__VUWd-"};